"use strict";
import _ from "underscore";
import ApiService from "../services/api_service";
var failureMessage = "Settings failed to load. Please refresh your browser to try again.";
var FeaturesService = {
  features: {},
  updateFeatures: function(features) {
    this.features = features;
    Promise.resolve(features);
  }
};
var loadFeatures = function() {
  ApiService.addErrorHandler($.ajax({
    url: "/api/features",
    type: "get",
    cache: false
  }), failureMessage).then(function(data) {
    FeaturesService.updateFeatures(data);
    return data;
  });
};
FeaturesService.ready = _.once(function() {
  return Promise.resolve().then(() => loadFeatures());
});
export default FeaturesService;
